import React from 'react';
import { useSubscription } from '../context/SubscriptionContext';

const UpgradeModal = ({ isOpen, onClose, onUpgrade }) => {
  const { 
    getCurrentTier, 
    getVehicleLimit,
    SUBSCRIPTION_TIERS 
  } = useSubscription();

  const currentTier = getCurrentTier();
  const vehicleLimit = getVehicleLimit();

  if (!isOpen) return null;

  const handleUpgradeClick = () => {
    onUpgrade();
    onClose();
  };

  return (
    <div className="modal-backdrop upgrade-modal-backdrop">
      <div className="modal upgrade-modal">
        <button 
          className="modal-close" 
          type="button" 
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
        
        <div className="upgrade-modal-content">
          <div className="upgrade-header">
            <div className="limit-icon">🚗</div>
            <h2>Vehicle Limit Reached</h2>
            <p>You've reached the {vehicleLimit} vehicle limit for your {currentTier.name} plan</p>
          </div>

          <div className="upgrade-comparison">
            <div className="current-plan">
              <h3>Current Plan: {currentTier.name}</h3>
              <div className="plan-price">
                £{currentTier.price}<span>/month</span>
              </div>
              <div className="plan-limit">
                <span className="limit-reached">✗ {vehicleLimit} vehicle limit</span>
              </div>
            </div>

            <div className="upgrade-arrow">→</div>

            <div className="premium-plan">
              <h3>Premium Plan</h3>
              <div className="plan-price premium">
                £{SUBSCRIPTION_TIERS.PREMIUM.price}<span>/month</span>
              </div>
              <div className="plan-benefits">
                <div className="benefit">
                  <span className="benefit-icon">✓</span>
                  <span>Unlimited vehicles</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon">✓</span>
                  <span>Advanced reporting</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon">✓</span>
                  <span>Priority support</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon">✓</span>
                  <span>Custom branding</span>
                </div>
              </div>
            </div>
          </div>

          <div className="upgrade-actions">
            <button 
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              className="upgrade-btn premium"
              onClick={handleUpgradeClick}
            >
              Upgrade to Premium
            </button>
          </div>

          <div className="upgrade-note">
            <p>
              <strong>Note:</strong> You can add your vehicle after upgrading to Premium. 
              Your upgrade will take effect immediately.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;




















